export const FILE_SIZE_LIMIT = 15728640; // bytes in 15 mb